import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { PrimaryButton } from '@huggg/react-components'
import { useAnalytics } from 'hooks';
import { interpolate } from 'utilities/interpolate';
import { getBasePathname, getProductName } from 'utilities/huggg';
import dictionary from 'config/dictionary';

const RedeemButton = props => {
  const { huggg, onClick: passedClickHandler = () => { } } = props;
  const analytics = useAnalytics();

  const buttonText = useMemo(() => {
    return interpolate(
      dictionary.moreInformationPage.huggg.redeemButton,
      '[product_name]',
      <>{getProductName(huggg)}</>
    );
  }, [huggg]);

  return (
    <Link
      onClick={() => {
        analytics.buttonClickHugggActionsRedeem();
        passedClickHandler()
      }}
      to={`${getBasePathname(huggg)}/redeem`}
      style={{ width: '320px', textDecoration: 'none' }}
    >
      <PrimaryButton label={buttonText} />
    </Link>
  );
};

RedeemButton.propTypes = {
  huggg: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default RedeemButton;
